export default function prefixProperties<
  Prefix extends string,
  Properties extends Record<string, any>,
>(
  prefix: Prefix,
  properties: Properties,
): { [K in keyof Properties & string as `${Prefix}${K}`]: Properties[K] } {
  return Object.entries(properties).reduce((acc, [key, value]) => {
    ;(acc as any)[`${prefix}${key}`] = value
    return acc
  }, {} as { [K in keyof Properties & string as `${Prefix}${K}`]: Properties[K] })
}
